import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import InputWithButton from "../../../common/interactive/InputWithButton"

import classes from './FilterSearchContainer.module.css'
import OutsideClickComponent from "../../../fragments/OutsideClickComponent"
import { detailedSearchOptions } from "../../../../assets/data"
import CheckboxCell from "../../../common/interactive/CheckboxCell"
import { filterActions } from "../../../../store/filter"
import { workqueueActions } from "../../../../store/workqueue"
import { detailsActions } from '../../../../store/details'
import {
    clearPersistedWorkQSearch,
    deriveSearchUIFromPersisted,
    getPersistedWorkQSearchParams,
    persistWorkQSearch,
} from "../../../../lib/filters"


export default function FilterSearchContainer({mainSelectAction, workQ, showGlobalSearch = true}) {
    const dispatch = useDispatch()

    const [showSearchResults, setShowSearchResults] = useState(false)



    const requesterIdStored = useSelector(state => state.filter.requesterId)
    let requesterId = 'filter_search_requester_id'
    const masterLoading = useSelector(state => state.filter.loading)



    const [currentValue, setCurrentValue] = useState('')
    const [optionsOpened, setOptionsOpened] = useState(false)
    
    const [detailedSearch, setDetailedSearch] = useState(null)
    const [globalSearch, setGlobalSearch] = useState(0)

    const [compoundSearch, setCompoundSearch] = useState([])

    const optionsSnapshotRef = useRef(null)


    function setCurrentValuehandler(value) {
        setCurrentValue(value)
    }

    const selectedFilters = useSelector(state => state.filter.filters)
    const workqSearch = useSelector(state => state.filter.workqSearch)
    const searchParams = useSelector(state => state.filter.searchParams)

    function applySearch(term) {
        const trimmed = term?.trim()
        if (!trimmed) {
            return
        }

        let searchObj = {
            ...selectedFilters,
        }

        detailedSearchOptions.forEach(item => {
            delete searchObj[item.apiProp]
        })
        delete searchObj.search
        delete searchObj.search_global

        let searchParamsToSave = {}
        if (!compoundSearch || compoundSearch.length == 0) {
            searchParamsToSave.search = trimmed
        } else {
            compoundSearch.forEach(item => {
                searchParamsToSave[item.apiProp] = trimmed
            })
        }
        searchObj.page = 1

        if (globalSearch) {
            searchObj.search_global = 1
            searchParamsToSave.search_global = 1
        }

        dispatch(filterActions.setFiltersMultiple({...searchObj, ...searchParamsToSave}))
        dispatch(filterActions.setSearchParams(searchParamsToSave))
        if (workQ?.slug) {
            persistWorkQSearch(workQ.slug, {
                searchParams: searchParamsToSave,
                compoundSearch,
            })
        }
        dispatch(workqueueActions.setRefreshApi())
        dispatch(detailsActions.setIsVerticalListOpened(true))
        dispatch(filterActions.setRequesterId(requesterId))
    }

    const searchPatientHandler = async (event) => {
        event.preventDefault()

        const fd = new FormData(event.target)
        const data = Object.fromEntries(fd.entries())

        if (data.header_search_filter != '') {
            applySearch(data.header_search_filter)
        }

        event.target.reset()
    }

    const clearSearchhandler = () => {
        setShowSearchResults(false)

        let searchObj = {
            ...selectedFilters,
        } 

        //remove all search related params  
        detailedSearchOptions.forEach(item => {
            delete searchObj[item.apiProp]
        })
        delete searchObj.search
        delete searchObj.search_global

        setGlobalSearch(0)
        setCurrentValue('')
        setCompoundSearch([])

        if (workQ?.slug) {
            clearPersistedWorkQSearch(workQ.slug)
        }

        dispatch(filterActions.setFiltersMultiple(searchObj))
        dispatch(filterActions.setSearchParams({}))
        dispatch(workqueueActions.setRefreshApi()) //filters do not refresh the api anymore!!!1
    }

    function openSearchOptions() {
        optionsSnapshotRef.current = {
            globalSearch,
            compoundSearch: compoundSearch.map(o => o.value).sort().join(','),
            searchTerm: (currentValue || '').trim(),
        }
        setOptionsOpened(true)
    }

    function anythingChangedSinceOpen() {
        const snap = optionsSnapshotRef.current
        if (!snap) {
            return false
        }
        const currentCompound = compoundSearch.map(o => o.value).sort().join(',')
        const currentTerm = (currentValue || '').trim()
        return (
            snap.globalSearch !== globalSearch ||
            snap.compoundSearch !== currentCompound ||
            snap.searchTerm !== currentTerm
        )
    }

    function closeSearchOptions() {
        if (currentValue.trim() && anythingChangedSinceOpen()) {
            applySearch(currentValue)
        }
        optionsSnapshotRef.current = null
        setOptionsOpened(false)
    }

    const detailSearchOptions = () => {
        if (optionsOpened) {
            closeSearchOptions()
        } else {
            openSearchOptions()
        }
    }


    const removeFilterHandler = () => {
        setDetailedSearch(null)
    }

    function showResultsHandler() {
        setShowSearchResults(true)
    }
    function globalSearchHandler(value) {
        setGlobalSearch(value.data.value)
    }

    const setDetailedSearchOption = (value) => {
        let arr = [...compoundSearch]

        const index = arr.findIndex(object => {
            return object.value == value.value
        })

        if (index !== -1) { // the item is allready there and should be removed!
            arr.splice(index, 1)
            setCompoundSearch(arr)
        } else {
            setCompoundSearch(prevState => prevState = [...prevState, value])
        }

    }

    useEffect(() => {
        if (!workQ?.slug) {
            return
        }
        const ui = deriveSearchUIFromPersisted(workQ.slug, searchParams)
        setCurrentValue(ui.currentValue)
        setGlobalSearch(ui.globalSearch)
        setCompoundSearch(ui.compoundSearch)
    }, [workQ?.slug, searchParams])

    useEffect(() => {
        if (!workQ?.slug) {
            return
        }
        const persisted = getPersistedWorkQSearchParams(workQ.slug)
        const hasActiveSearch =
            (searchParams && Object.keys(searchParams).length > 0) ||
            (persisted && Object.keys(persisted).length > 0)

        if (!hasActiveSearch) {
            setCurrentValue('')
            setGlobalSearch(0)
            setCompoundSearch([])
        }
    }, [workqSearch, workQ?.slug, searchParams])

    return <div className={classes.header_search_container}>
        <div className={classes.header_search_container_inner}>
            <form className={classes.header_search_form} onSubmit={searchPatientHandler}>
                <InputWithButton label="Q-Search" type="text" name="header_search_filter" required={false} placeholder="" buttonIcon='ti ti-search' clearInputExtraTask={clearSearchhandler} isLoading={masterLoading && requesterIdStored == requesterId} foucsExtraTask={showResultsHandler} actionOnKeyUp={true} keyupExtra={setCurrentValuehandler} currentValue={currentValue}/>
            </form>
        </div>
        <button title="detailed search options" onClick={detailSearchOptions} className={classes.open_detailed_search}><i className="ti ti-dots-vertical"></i></button>
        {optionsOpened && <div className={classes.detailed_search_container}>
            <OutsideClickComponent task={closeSearchOptions}>
                {showGlobalSearch && <div className={classes.detailed_search_container_header}>
                    <CheckboxCell label={'Global Search'} direction={'reverse'} title={"Check to search all workqs"} action={globalSearchHandler} checked={globalSearch}/>
                </div>}
                <h4>Search by:</h4>
                <div className={classes.detailed_search_buttons}>
                    {detailedSearchOptions && detailedSearchOptions.map(item => (
                        <button key={item.label} onClick={() => {setDetailedSearchOption(item)}} className={compoundSearch.some(el => el.value == item.value) ? classes.option_selected : ''}>{item.label}</button>
                    ))}
                </div>
                
        </OutsideClickComponent>
        </div>}
        {detailedSearch && <div className={classes.filter_container}>
            You are searching in: 
            <div className={classes.filter_container_term}>{detailedSearch.label} </div> 
            <button onClick={removeFilterHandler} title="Remove Filter" className={classes.remove_filter_button}><i className="ti ti-x"></i></button>
        </div>}
    </div>
}
